import { Box, Typography, Link } from "@mui/material";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import CheckmarkDialogueIcon from "../icons/CheckmarkDialogueIcon";
import { useScrollToTop } from "../../hooks/useScrollToTop";
import surveyLinkStyles from "../../styles/surveyLinkStyles";

const SubmissionErrorBanner = ({ translationKey = "submissionError" }) => {
  const { t } = useTranslation("common");
  const theme = useTheme();
  const VITE_SMS_NUMBER = import.meta.env.VITE_SMS_NUMBER || "988";
  useScrollToTop();

  return (
    <Box
      sx={{
        borderTop: `1px solid ${theme.palette.royalPurple}`,
        borderBottom: `1px solid ${theme.palette.royalPurple}`,
        backgroundColor: theme.palette.lightPurple,
        my: "12px",
        py: "25px",
        px: "50px",
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        flexWrap: { lg: "wrap" },
        alignItems: { xs: "flex-start", lg: "center" },
        columnGap: { lg: "6px" },
        rowGap: { xs: "3px", lg: "8px" },
      }}
    >
      <CheckmarkDialogueIcon
        fill={theme.palette.royalPurple}
        sx={{ flexShrink: 0, fontSize: "35px", mt: "10px" }}
      />
      <Typography
        sx={{
          color: theme.palette.royalPurple,
          fontFamily: "Public Sans",
          fontWeight: 700,
          fontSize: { xs: "17px", lg: "20px" },
        }}
      >
        {t(`${translationKey}.title`)}
      </Typography>
      <Typography
        sx={{
          color: "black",
          fontFamily: "Public Sans",
          fontSize: "14px",
          flexBasis: { lg: "100%" },
          whiteSpace: "pre-line",
          lineHeight: { xs: 1.9, lg: 1.5 },
        }}
      >
        <Trans
          t={t}
          i18nKey={`${translationKey}.body`}
          components={{
            returnLink: (
              <Link
                href={`sms:${VITE_SMS_NUMBER}`}
                sx={(theme) => ({
                  ...surveyLinkStyles(theme),
                  color: "black",
                  textDecorationColor: "black",
                  fontWeight: 700,
                  textDecoration: "underline",
                  textDecorationThickness: "1.5px",
                  textUnderlineOffset: "2px",
                })}
              />
            ),
            safeSpaceLink: (
              <Link
                href="https://www.safespace.vibrant.org/en/"
                target="_blank"
                rel="noopener noreferrer"
                sx={(theme) => ({
                  ...surveyLinkStyles(theme),
                  color: "black",
                  textDecorationColor: "black",
                  fontWeight: 700,
                  textDecoration: "underline",
                  textDecorationThickness: "1.5px",
                  textUnderlineOffset: "2px",
                })}
              />
            ),
          }}
        />
      </Typography>
    </Box>
  );
};

SubmissionErrorBanner.propTypes = {
  translationKey: PropTypes.string,
};

export default SubmissionErrorBanner;
